import React from 'react'
import classNames from 'classnames'
import { Warning } from '../svg'

export const colorHash = {
  red: 'border-core-danger-600 bg-core-danger-600',
  yellow: 'bg-core-warning-500 border-core-warning-500',
}

interface Props {
  errorText?: string | null
  color?: 'red' | 'yellow'
  size?: 'lg' | 'sm'
  className?: string
}

const ErrorBox: React.FC<Props> = ({
  errorText,
  color = 'red',
  size = 'lg',
  className,
}) => {
  if (!errorText) return null

  return (
    <div
      className={classNames(
        {
          'flex flex-row items-center rounded bg-opacity-10 text-lg text-core-gray-950':
            true,
          'border-2 p-2.5': size === 'lg',
          'border p-1.5': size === 'sm',
          [colorHash[color]]: true,
        },
        className
      )}
    >
      <div className="flex h-full flex-col items-center justify-center">
        <Warning
          className={classNames({
            'text-core-warning-500': color === 'yellow',
            'text-core-danger-600': color === 'red',
            'text-2xl': size === 'lg',
            'text-xl': size === 'sm',
          })}
        />
      </div>
      <span
        className={classNames({
          'ml-2': true,
          'text-sm': size === 'lg',
          'text-xs': size === 'sm',
        })}
      >
        {errorText}
      </span>
    </div>
  )
}

export default ErrorBox
